import { useBrand } from "@/brand";

const MASTS_IMG =
  "https://images.unsplash.com/photo-1687193546317-68dcb4cff65b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHw0fHxtb3VudGFpbiUyMHBvd2VyJTIwZ3JpZCUyMG1hc3R8ZW58MHx8fHwxNzkwODUxMDE5fDA&ixlib=rb-4.1.0&q=85";
const LIGHTING_IMG =
  "https://images.unsplash.com/photo-1549399905-5d1bad747576?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBpbGx1bWluYXRlZCUyMHdvcmtzcGFjZXxlbnwwfHx8fDE3OTA4NTEwMTl8MA&ixlib=rb-4.1.0&q=85";

const cards = [
  {
    img: MASTS_IMG,
    alt: "Høyspentmaster i norsk fjellterreng",
    tag: "Overføringsnett & Nettleie",
    title: "Høyspentlinjer og sentralnettet",
    text: "Kraften transporteres gjennom det nasjonale overføringsnettet. Vår rådgivning hjelper bedriften med å planlegge forbruket for lavere effekttopper og gunstigere nettleie.",
  },
  {
    img: LIGHTING_IMG,
    alt: "Moderne opplyst arbeidsplass",
    tag: "Forbruk & Drift",
    title: "Uavbrutt energi til kontor og produksjon",
    text: "Når lysene tennes og maskinene starter, sørger {BRAND} for at energien dere bruker alltid er sikret til konkurransedyktige B2B-vilkår.",
  },
];

const InfraSection = () => {
  const brand = useBrand();
  return (
  <section id="infrastruktur" className="py-24 bg-white border-b border-slate-200" data-testid="infra-section">
    <div className="max-w-7xl mx-auto px-6">
      <div className="max-w-2xl mb-16">
        <span className="text-xs font-bold uppercase tracking-widest text-emerald-600">
          Kraftselskap og infrastruktur
        </span>
        <h2 className="font-serif-heading text-3xl sm:text-4xl font-bold text-[#0B132B] mt-2 tracking-tight">
          Fra kraftbørs og strømnett til bedriftens stikkontakt
        </h2>
        <p className="text-slate-600 mt-4 leading-relaxed">
          Strømmarkedet er sammensatt av kraftproduksjon, overføringsnett og
          børshandel. Vi optimaliserer innkjøpene slik at bedriften din unngår
          de dyre pristoppene i nettet.
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-8 items-stretch mb-12">
        {cards.map((card) => (
          <div
            key={card.title}
            className="p-6 rounded-2xl bg-slate-900 text-white flex flex-col justify-between overflow-hidden relative"
            data-testid={`infra-card-${card.title.toLowerCase().replace(/\s+/g, "-")}`}
          >
            <div className="w-full aspect-[16/9] rounded-xl overflow-hidden relative mb-6">
              <img src={card.img} alt={card.alt} className="w-full h-full object-cover" loading="lazy" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0B132B]/60 via-transparent to-transparent" />
            </div>
            <div>
              <span className="text-xs font-bold text-emerald-400 uppercase tracking-wider">
                {card.tag}
              </span>
              <h3 className="text-xl font-bold text-white mt-1">{card.title}</h3>
              <p className="text-sm text-slate-300 mt-2 leading-relaxed">{card.text.replace("{BRAND}", brand.name)}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
  );
};

export default InfraSection;
